import { Picture } from '@emico-react/image'
import * as React from 'react'

import { Maybe } from '@emico/graphql-schema-types'

import styles from './FlavourImage.module.scss'
import Col from '../../../layout/Col'
import Container from '../../../layout/Container'
import Row from '../../../layout/Row'
import breakpoints from '../../../theme/breakpoints'
import makeMediaUrl, { MediaType } from '../../../utils/makeMediaUrl'

interface ProductFullWidthType {
    image: Maybe<string>
}

const FlavourImage = ({ image }: ProductFullWidthType) => {
    const imageUrl = image ? makeMediaUrl(image, MediaType.Product) : ''

    return (
        <Container>
            <Row className={styles.default}>
                <Col>
                    <Picture
                        alt=""
                        className={styles.image}
                        lazy
                        breakpoints={{
                            [breakpoints.xs]: {
                                url: imageUrl,
                                width: 748,
                                height: 200,
                            },
                            [breakpoints.sm]: {
                                url: imageUrl,
                                width: 932,
                                height: 400,
                            },
                            [breakpoints.lg]: {
                                url: imageUrl,
                                width: 1870,
                                height: 500,
                            },
                        }}
                        params={{
                            resizingType: 'fill-down',
                        }}
                    />
                </Col>
            </Row>
        </Container>
    )
}

export default FlavourImage
